import * as React from "react";

export function MapMarker(props) {
  return (
    <svg
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12 12"
      {...props}
    >
      <path
        d="M1.885 2.879a3.652 3.652 0 00-.984 3.863 5.036 5.036 0 002.249 3.542 6.734 6.734 0 003.373.966 5.365 5.365 0 002.951-.805 3.968 3.968 0 001.546-3.059q.844-4.18-1.406-5.634A5.324 5.324 0 005.117.948a11.52 11.52 0 00-3.232 1.93z"
        fill="#fff"
        stroke="#000"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      />
      <path
        d="M4.315 4.77a2.722 2.722 0 00-.242 2.328A1.54 1.54 0 004.94 8.15a2.706 2.706 0 001.419.225 3.507 3.507 0 001.42-.45 1.79 1.79 0 00.865-1.052 2.803 2.803 0 00-.727-2.63 2.106 2.106 0 00-2.389-.45 2.1 2.1 0 00-1.212.977z"
        fill="#fff"
        stroke="#000"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      />
    </svg>
  );
}

export function MapMarkerActive(props) {
  return (
    <svg
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      {...props}
    >
      <path
        d="M2.841 3.858a5.005 5.005 0 00-1.24 5.118 6.713 6.713 0 002.834 4.691 8.184 8.184 0 004.251 1.28 6.516 6.516 0 003.72-1.066 5.349 5.349 0 001.948-4.051q1.063-5.537-1.771-7.464A6.445 6.445 0 006.915 1.3 14.392 14.392 0 002.84 3.858z"
        stroke="#fff"
        strokeMiterlimit={10}
        strokeWidth={1.938}
      />
      <path
        d="M5.904 6.363A3.767 3.767 0 005.6 9.447a2.02 2.02 0 001.091 1.394 3.263 3.263 0 001.789.298 4.27 4.27 0 001.789-.597 2.349 2.349 0 001.09-1.393 3.843 3.843 0 00-.916-3.482 2.56 2.56 0 00-3.01-.597 2.677 2.677 0 00-1.528 1.293z"
        stroke="#fff"
        strokeMiterlimit={10}
        strokeWidth={1.938}
      />
    </svg>
  );
}

export function TickIcon(props) {
  return (
    <svg
      width={12}
      height={9}
      viewBox="0 0 12 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.076 8.773l-3.9-3.9a.6.6 0 010-.849l.848-.848a.6.6 0 01.849 0L4.5 5.803 10.127.176a.6.6 0 01.849 0l.848.848a.6.6 0 010 .849l-6.9 6.9a.6.6 0 01-.848 0z"
        fill="currentColor"
      />
    </svg>
  );
}

export function PlusIcon(props) {
  return (
    <svg
      width={12}
      height={12}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.5 5H7V.5a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5V5H.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5H5v4.5a.5.5 0 00.5.5h1a.5.5 0 00.5-.5V7h4.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5z"
        fill="#555"
      />
    </svg>
  );
}

export function MinusIcon(props) {
  return (
    <svg
      width={12}
      height={2}
      viewBox="0 0 12 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.5 0H.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h11a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5z"
        fill="#555"
      />
    </svg>
  );
}

export function SearchIcon(props) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.78 13.833l-3.116-3.115a.75.75 0 00-.53-.219h-.51a6.468 6.468 0 001.375-4c0-3.59-2.91-6.499-6.5-6.499S0 2.91 0 6.5s2.91 6.499 6.5 6.499c1.509 0 2.896-.513 3.999-1.375v.51c0 .2.078.39.219.53l3.115 3.116a.747.747 0 001.06 0l.884-.885a.753.753 0 00.003-1.062zM6.5 10.499c-2.21 0-4-1.787-4-4 0-2.209 1.787-4 4-4 2.209 0 3.999 1.788 3.999 4 0 2.21-1.787 4-4 4z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ChevronRight(props) {
  return (
    <svg
      width={8}
      height={12}
      viewBox="0 0 8 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.09 6.466l-5.341 5.34a.66.66 0 01-.933 0l-.623-.622a.66.66 0 010-.932L4.424 6 .192 1.748A.66.66 0 01.193.816L.816.193a.66.66 0 01.933 0l5.34 5.34a.66.66 0 010 .933z"
        fill="currentColor"
      />
    </svg>
  );
}

export function DoubleChevronDown(props) {
  return (
    <svg
      width={9}
      height={8}
      viewBox="0 0 9 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.505.78L4.45 4.835a.233.233 0 01-.329 0L.068.781a.233.233 0 010-.33L.452.069a.233.233 0 01.329 0l3.506 3.498L7.792.068a.233.233 0 01.33 0l.383.384a.233.233 0 010 .329zm0 2.769l-.384-.383a.233.233 0 00-.329 0L4.287 6.664.78 3.166a.233.233 0 00-.33 0l-.383.383a.233.233 0 000 .329l4.054 4.054a.233.233 0 00.33 0l4.053-4.054a.233.233 0 000-.33z"
        fill="currentColor"
      />
    </svg>
  );
}

export function BookIcon(props) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.372 6l-.064.002C12.752 6.091 9.917 6.408 8 7.49 6.084 6.409 3.25 6.09 1.693 6.002a1.086 1.086 0 00-.065-.001C.991 6 0 6.449 0 7.569v5.564A1.58 1.58 0 001.51 14.7c1.076.056 3.768.283 5.532 1.17.17.087.354.13.537.13h.842c.182 0 .366-.043.537-.13 1.764-.887 4.456-1.113 5.531-1.17A1.58 1.58 0 0016 13.133V7.57c0-1.12-.99-1.568-1.628-1.568zM7.25 14.327c-1.895-.806-4.318-1.053-5.66-1.124-.054-.003-.09-.038-.09-.069l-.014-5.576a.368.368 0 01.12-.058c1.121.064 3.91.319 5.644 1.29v5.537zm7.25-1.193c0 .031-.036.066-.09.069-1.342.07-3.763.317-5.66 1.124V8.79c1.729-.968 4.505-1.224 5.623-1.288.044.004.118.034.127.068v5.564zM8 6a3 3 0 100-6 3 3 0 000 6zm0-4.5c.827 0 1.5.673 1.5 1.5S8.827 4.5 8 4.5 6.5 3.827 6.5 3 7.173 1.5 8 1.5z"
        fill="currentColor"
      />
    </svg>
  );
}

export function CalendarIcon(props) {
  return (
    <svg
      width={14}
      height={16}
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.5 2H11V.375A.376.376 0 0010.625 0h-1.25A.376.376 0 009 .375V2H5V.375A.376.376 0 004.625 0h-1.25A.376.376 0 003 .375V2H1.5A1.5 1.5 0 000 3.5v11A1.5 1.5 0 001.5 16h11a1.5 1.5 0 001.5-1.5v-11A1.5 1.5 0 0012.5 2zm-.188 12.5H1.688a.188.188 0 01-.188-.188V5h11v9.313a.188.188 0 01-.188.187z"
        fill="currentColor"
      />
    </svg>
  );
}

export function CrossIcon(props) {
  return (
    <svg
      width={12}
      height={12}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.273 6l3.846-3.846.793-.793a.3.3 0 000-.424l-.848-.849a.3.3 0 00-.425 0L6 4.728 1.36.087a.3.3 0 00-.423 0l-.85.848a.3.3 0 000 .425L4.728 6l-4.64 4.638a.3.3 0 000 .425l.85.848a.3.3 0 00.424 0L6 7.273l3.845 3.846.793.793a.3.3 0 00.425 0l.848-.848a.3.3 0 000-.425L7.273 6z"
        fill="currentColor"
      />
    </svg>
  );
}

export function MapDot(props) {
  return (
    <svg
      width={12}
      height={12}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.281 3.463c-1.196.996-1.554 2.42-1.076 4.412.478 1.993 1.315 3.274 2.511 3.986C5.031 12.573 6.227 13 7.542 13c1.316 0 2.392-.285 3.348-.854.957-.57 1.555-1.708 1.794-3.416.598-3.132.12-5.267-1.554-6.406C9.335 1.043 7.662.758 5.987 1.185A14.868 14.868 0 002.28 3.463z"
        fill="#B1BE41"
        stroke="#687F4A"
        strokeWidth={1.5}
      />
    </svg>
  );
}

export function ShoppingCartIcon(props) {
  return (
    <svg
      width={20}
      height={17}
      viewBox="0 0 20 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M.75.5a.75.75 0 100 1.5h3.477l3.32 9.01a.75.75 0 00.703.49h11a.75.75 0 000-1.5H8.773L5.453.99A.75.75 0 004.75.5h-4zm7.101 1.007a.75.75 0 00-.793 1.031l2.5 6A.75.75 0 0010.25 9h8.5a.75.75 0 00.75-.75v-5.5a.75.75 0 00-.649-.743l-11-.5zM10.75 7.5L8.946 3.17 18 3.405V7.5h-7.25zm.5 6.75a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm5.5 1.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
        fill="currentColor"
      />
    </svg>
  );
}

export function MapDotActive(props) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.708 4.284C1.114 5.612.636 7.51 1.273 10.167c.638 2.658 1.754 4.366 3.348 5.315C6.375 16.43 7.97 17 9.723 17c1.754 0 3.189-.38 4.464-1.139 1.276-.759 2.073-2.277 2.392-4.555.797-4.175.159-7.022-2.073-8.54-2.392-1.709-4.623-2.089-6.855-1.52a19.824 19.824 0 00-4.943 3.038z"
        fill="#687F4A"
        stroke="#B1BE41"
        strokeWidth={1.5}
      />
    </svg>
  );
}

export function AustraliaIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={42} height={42} {...props}>
      <path
        fill="#333333"
        d="M33.9 28.93l-.13.113-1.136.099.027-.051-.208.076-.178-.05.068.065.007.01-.23.147.412-.172-.337.197-.491.5-.307.098h-.257l.049.197.155-.099-.05.325-.128-.124-.106-.2.027.076-.102-.051-.102.073-.13-.223.077.026-.027-.051-.181.025-.178-.124.026-.149.102-.026-.053-.149h-.181l-.023.2-.08-.025-.154.098-.231-.196.23.047.156-.197-.155-.299-.333.248h-.13l.103.077.182-.051-.053.149h-.182l-.306.2-.39.372-.953-.5-.205.052-.31-.15-.155.175-.076-.05-.08.025v-.124l-.283-.222-.053-.004v-.082l-.308-.022-.155-.125-.012-.037-.3-.388-.205-.276.05-.073-.103-.15.13-.125.026-.125-.198-.502.069.102-.156-.326-.13-.099.168.25-.22-.276-.335-.25.388.272-.388-.297-.133-.026-.152.125-.364-.025.285-.25.026-.55.027.077.05-.026-.024-.044-.364-.605-.156.348-.027.25-.129.275.053.051-.102.048-.182-.073-.206.15-.262.026.133-.378.308.077.053-.051.053-.301-.026-.147-.053.022.08-.147-.054-.15.053-.026.076-.223.312-.301-.156-.275.205-.176-.076-.074-.026-.227-.13-.275v.502l-.102-.051-.156.176-.182.499-.179.051-.053-.051-.053.099.08-.026-.312.15-.387.426v.176l-.053-.051-.103.051-.027.198-.075.052.178-.074-.05.275-.128-.15-.13.073-.311-.374-.106.051.08-.15v.048l.102.025-.027.026.053.1.103-.026-.05-.023-.026-.077-.027.077-.155-.674-.285-.254v-.146l-.156-.202.053-.051-.129-.022.076.073-.156-.099-.076.048-.076-.15.05.15-.156-.15.053-.074-.102-.026.05-.073-.05-.103h.129l-.027.077.076-.099-.102-.202-.103-.025-.156.077v-.125l.076-.026-.285-.275-.049.074-.053-.048-.053.026.08.073h-.312l-.311-.25H20l-.053.026.026.048h-.231l-.365-.275-.49-.25-.285.15-.52-.05-.13.025-.8.077-.058.03v.057l-.563.271-.833.25-.438.021-.392-.047-.205.047-.932.527-.468.147-.103.102-.107.4-.361.347-.13-.048-.182.125-.027-.103-.076-.047-.339.025-.026.074-.179-.052-.053.103h-.13l-.102-.176-.183.073-.335-.098-.65.076-.13.1-.339-.052h-.076l-.361.326.103.099-.13-.026v.103l-.103-.026-.026.099-.339-.1.053.049-.129.05-.027.1-.232.098-.026.15-.183.026.027.077h-.21l.027-.102-.05.025-.053.099.13.051-.054.026-.232-.077-.053.103-.205-.125-.366.048-.152-.074-.08.074-.205-.125h.13l-.107-.073-.023.073-.312-.099-.236-.347-.286-.15-.152.025-.026.048-.103-.275v-.523l.152.098h.133l.282-.322-.076-.574.102-.198-.026-.176.053-.077-.027-.124.13-.026v-.047l-.13.073-.026-.374-.518-1.047-.076-.399v-.05l.027-.447-.107-.352-.232-.3.027-.099-.08-.15-.285-.322-.05-.253.05-.124-.156-.4-.674-.947.107.076.022-.2v.274l.08.05-.026-.325.102.4.027-.151.053.3.023-.15.027.176.156-.073.026-.227-.258-.198-.08-.377v.102l-.05-.05.076-.199.21.323-.027.274.13-.099v-.124l.026.274.13.198.129-.15-.027-.275h.08l-.027-.124-.08-.022-.285-.55-.103-.076-.053-.198.027-.05-.206-.327.05-.446.262-.352-.026-.296.05-.15-.13-.326.259-.597.182-.051-.103.3.027.172.05-.048-.05.173.13-.074.049.074.106-.125-.026-.048.05.026-.05-.051.076-.125-.027-.098.054.022.053-.022.027-.15.205-.125.495-.124.129-.202.13-.025.075-.15.21-.1.023-.124.08.051.258-.124h.053l-.026-.026.13-.15h.052l-.08.125.054.025.076.026.183-.103.026.077.156.074.206-.1v.026l.13-.025.052-.1h.076l-.022-.05.205-.125v.051l.544-.102.183-.223.026-.026.05.026.027.025v-.025l-.027-.052.236.052.076.073.103-.073.08-.052h.178l.183-.022.727-.3.312-.373.13-.227-.027-.1.129-.025-.053-.073.08-.102.102-.022.366-.253v-.099l-.183-.025.05-.173-.077-.175.027-.224.13-.102-.054-.022.08-.103.103-.025v-.048l.102.048-.049-.099.023-.073.21.025-.077-.076.152-.25.08-.025.053.077-.08.022-.026.102.08.074h.076v.2l.103.074.08.25.155.15v-.125l.05-.125.053.026-.103-.176.077-.026.235.227-.133-.227.08.026-.053-.051.13-.125-.05-.022v.048l-.107.051-.05-.15-.182-.051.103-.073-.076-.026-.027.051-.05-.077h.18l-.13-.073h.183l-.08-.051.08.026-.027-.052-.103-.022.05-.025-.05-.077.05.051-.027-.051.08.026v-.052l.103.052h-.053l.026.05h-.05l.13.048v-.022l.103.074-.053-.074h.053l-.076-.076.179.076.08.1.076.025-.076.022.121-.022-.045-.026.053-.051.05.051.232-.025-.103-.052-.179.026.05-.223.053.124.053-.025-.053-.026.102-.048h-.049l.023-.175.106-.077h-.08l.054-.048-.08.048-.069.117.046-.04-.053.073v-.019l-.027.044-.103-.274.076-.026-.049-.022.103-.077-.027-.025.103.025.026-.073.027.048.053-.1.076-.05v.05l.103.027.053.098.054-.047.13.099-.157-.125.076-.077h-.05v-.047l-.129.073-.053-.048.156-.128-.156.103.027-.077-.054-.026.156-.022-.026-.102.053-.022.076.172.107-.073.05.073h.129l-.13-.048.103-.102-.05-.022-.026.047-.156-.047.103-.077h-.077l-.08-.099.157-.077-.05-.022.103-.102-.027.102.053-.051.027.073.05-.099.08.026v-.275l.102.052-.053.073-.023.223.076-.198v.074l.103-.022-.027.099.08.073v-.125h.103l-.05-.099.077-.05-.027-.074.103-.077-.153-.073v-.051l.023.05v-.05l.08.025.076-.05-.05.05h.05l-.05.052h.05l.027.124.103-.051-.05-.048.023-.051.156-.099-.05.125.05-.026.08.15.027-.15.022.051.054-.051-.027-.077.137.022.046.004-.103-.048-.053-.124.102.022V8l.156.048.005.01.04-.06.037.096.073-.124.068.06-.068-.156.068.064.11-.064-.036-.156.141-.092-.068.028.032-.28.11-.06v.06l.105.032.288-.188.068.032-.21-.22v-.22l.247-.06v-.22l.074.065-.037-.064.11-.032.179.156v-.06h.104l-.215-.096h.074l-.037-.216.215.028-.037.16.074-.032v-.032l.068.124.068-.06-.068-.096.147.032-.178-.124.068-.064.178.032-.068-.22.283.064.074-.188.037.156.141.092.499-.06.178.092.178-.156.037.096.11-.064.068.156.037-.188.11-.06.247.06-.178-.06.036-.187.069-.032-.142-.097.178-.155h-.215l.074-.028-.074-.032h.074l-.11-.032.073-.032h-.074v-.06l-.32.028-.141.064-.037-.092-.142-.032.032-.032-.032-.064-.178.032.068-.064-.037-.06.179.032V5l.147.096.068.22.073-.096-.073-.032L18.578 5l.184.156-.037-.092L18.83 5l.037.188.073-.092.247.312.178-.124.074.032-.037-.096h.073l.252.376.21-.032-.031.091.104-.06.074.092.068-.06-.031.125.32-.156.141.032-.105.092.105.096.142-.096.037.096.073-.032.074.123-.074.156.105-.188.43.097.142-.156.11.215.43.156-.073-.092.215.032-.142-.064.179-.091.178-.032.037.06.393-.184-.288.28.105.064.037-.097.288-.123-.142.155.032.06.11-.028-.11.156h.073v.092l.074-.06.141.028.105-.06.11-.188-.251-.064.43-.28-.11.124h.073l.142.28h.11l-.073-.06.11-.064.215.188-.215.22v-.096h-.074l.037.096-.073.156h-.105l.036.124-.073-.092-.037.06-.073-.028.215.216-.215-.033.11.097-.11.188-.142.06.074-.092-.074-.156-.037.091-.105-.027-.036.156-.037-.156-.105.183-.037-.091-.105.064-.036.091.105.032-.069.06-.073-.027.037.28.068.031.147-.096-.179.344-.036.188-.215.096-.179.371-.215.064.074.22.178.156.105-.032v.064l.037-.032.571.312.142.247.394.156v.128l.11-.032.178.064-.037-.064.055-.016v-.01l.006.008.044-.014.467.28.357.096.053.062.063.019.104.103.05.233.186.08.104.13.186.027.158.103.054.026.445-.103.24-.183.05-.34.212-.26.186-.519-.054-.13.077-.313.159-.416-.105-.47.081-.26-.135-.286.135-.39h.105l-.054-.026.027-.027-.054.027.027-.076-.078-.237.132-.103.05-.13.108.183-.027-.13.054-.026-.135-.054.135-.05h-.135l-.104-.08.054-.026-.081-.023.027.103h-.078l.105-.26h.077l-.077-.027.131-.21.027.184.027-.103.05.026.055-.08-.054.054-.05-.08.026-.157.105-.023h-.081l.027-.183h.027l.077-.34-.023-.13.154-.05.082-.156.104-.027.027.027.027.023-.131.21.104-.054v-.05l.054.104h.077l.105.313v.39l.081.08.104-.027.132.05-.159.13.027.183.132.026v.103l.158.103-.077.237.155-.053-.024.237.078.26-.054.259.135.206.077.34.132.103.158-.076.054-.157.105.05.158-.13.132.34.181.053.108.157.159.023.05.107h.054l-.104.13.023.13.081-.027v.026l-.131.157.104.103.027.286.105.13v.183h-.05v.13l.313.417.13-.027-.05.13.16.286v.206h.05l-.132.443.186.313h.104l-.05.287.154.183.267.103.077.103h.082l.023-.103.108.233.236-.023v-.107l.158.34-.104-.053.154.156.109.027-.054-.13h.08l.051.183.159-.026.131.076v.027l-.027.026.108.104.077.026v-.103h.105l.027.103h.081v.077l.05-.023.159.26-.132-.108-.027.054-.077-.027.05.054-.077.026.077.077-.023.053.131.077-.054.026.027.08h.182l-.023.104.077-.054.105.103-.05.13h.026l-.027.08.105-.053v.237l.027-.054.104.103.027-.05-.054.287.159.363-.105.053.105-.027.027.05-.054.027h.108l-.081.183.158-.183.159.183.054.054-.054-.107-.078-.18.078-.13.027-.053.131.206.367.264-.05-.13.05.023-.077-.13.027-.077.05.027.027.103v-.103l.082.13-.028.027-.08-.027.053.103.055.027v-.08l.05.13-.027.21h-.05l.077.286-.05.05.077.156-.054.027.108.156.077-.103.344.466v-.05l.105.05v-.05l.104.05-.05-.103.077.027v.076l.054-.076-.027.103.105.027.13.34.132.13v-.027l.159.076-.027.08.027-.053.081.053-.027.103.158.184-.08.05.232.064.036-.084h-.074l.296-.226-.148-.151.185-.1v.175l.074.1-.33.671.1.073-.055.05h.078l-.024.13.05-.157.055.107h.054l-.108.416h.054l-.027.226.054.034-.054.206.027-.076.077.233-.131-.157v.08l.08.077-.107.053.08.077-.08.08.108.05-.054.08.08-.054.078.107.058.233.066.281.057-.002-.007.076.062.061-.004.054-.07.002-.003.039.077.102-.026.21-.051.022h.051l-.199.391.022.103-.073-.027.073.053-.073.437-.026.08-.177.467.026.516-.225.752-.177.152-.026.182h-.126l.1.053v-.053l.078.027-.026.205-.177.106-.1.156-.025-.053-.074.053-.1-.053.022.053-.047.05.025.026.1-.076.1.023-.303.182v-.076h-.048l.026.05-.103.182-.026-.103v.103h-.074l.026.102.074-.102-.074.209h-.1l.049.049-.026.13-.1.052V24.9l-.026.129-.073-.053.025.076.023-.023v.076l.051-.053v.026l-.026.21-.073-.054.025.08-.077-.027.052.05.073-.05-.025.13-.174.026.151.05-.125.026.074.026-.2.205v.183l-.077.026.052.076-.052.182-.176.08.103.023-.026.053.048-.026.051.155-.051.027v-.103l-.074.023.074.156-.173.053-.203.49-.1-.023.074.103-.125.102h.051l-.051.156.026.258-.1.414-.052.182-.048-.026.048.129-.048.102.1.027.052.129h-.052l-.052.027.026.208-.129.065-.015-.011.019-.054h-.078l-.006-.006zm-1.23-.72l.003-.026-.007-.022-.005.043.009.004zm-.174-.525l.007-.048-.015-.009-.005.03.013.027zm-2.783-.135l-.022-.077-.055-.05.028.093.049.034zm-.642-.474l-.106-.157-.074-.334-.085-.036.068.286.174.24h.023zm-.851-.498l-.022-.02-.059-.247-.203-.174-.062-.008.152.122.06.237.133.113v-.023zm-.986-.479l-.094-.046-.022.004.106.049.01-.007zM27 26.004v-5.24h-.143V26l.008.026.135-.022zm6.336-5.466l.033-.018-.001-.014-.029-.002-.003.034zm2.349.017l.01-.004.015-.069.077-.095-.084.008-.009-.031-.024.002-.011.092.026.097zM16.816 5.76l-.04.12L16 5.8h.082v-.16l.122.08.041-.08.04.12v-.093l-.04-.027v-.16h.082l-.164-.08.286-.2.082.16-.082.16.082-.04-.082.08.141-.035-.1-.525.286.16v.2h.04l-.04-.04.081-.08.041.2.163.08-.163-.24.245-.08.122.04h.041l.041.2V5.2l.082.04.04-.12.123.28-.082-.2.123-.16.04.12h.164L18 5.4l-.122.04v.16l-.123-.04-.122.2-.409.24-.408-.24zm6.342 2.392L23 8.199l.158-.094-.052-.093v-.117l.368-.047-.106-.07.264-.024-.053.047.053.094h.21v-.07L24 7.87l-.263.094.052.07-.157.024v.093l.262.023.053-.046.053.117h-.474l-.368-.094zM25.15 9.95l-.053.065-.134-.065.134-.109.214-.065.133.109-.106.021-.027-.065-.08.13-.08-.021zM4.238 18.234v.15L4 17.995v-.302l.238.542zm19.924 8.943l.114-.116.2.07-.057.092h-.371l-.029.092-.114.07-.229-.093-.2.046-.257.024-.171-.162.057-.115.943-.162-.058.138h.2l-.028.116zm4.917 3.67l.133.115.026.403-.159.173-.053-.057v-.116L29 31.02l.08-.173zm3.355.39l-.1-.02.15-.14.2.2h.1l-.024.04-.05.101.05-.04.05.1-.2.06-.076-.14-.1-.08v-.08zm-.061 3.07l.06.09.099-.018.04.16-.08-.09v.072l-.06.017-.06-.07.04-.036-.079-.018.04-.106zm.384-1.371l-.026.432.079.168-.053.072v-.144l-.131-.048.052-.144-.105.144.079.024h-.079l-.13.24.078-.024-.026.192-.105.048.078.12-.13.216-.106.024-.052-.12-.131-.024.131.072-.079.024.027.12-.106.072.053-.144-.053.024-.183-.216.131.192v.144l-.079-.024-.026.264-.105-.048v-.072l-.026.072-.052-.048v-.072l-.027.048.105.12-.105.048.08.024-.027.096-.105-.024.079.072-.106.144h-.157l-.105-.168.026.072-.288-.048-.184.072-.078-.192.052.024v-.072l.184.048.026-.048h-.21l-.052-.144-.053.096.053.024h-.079l-.131-.264-.131-.048-.131-.36-.08-.024-.078-.432.236.192.027.144.052-.168h-.052l-.132-.216-.078.072v-.216l-.263-.312.053-.048-.184-.24-.105-.408.08-.144-.027-.192.367.168v-.048l.105.024v-.096l.052.12h.158l.603.336.236-.048.052.12-.026-.096.131-.096.158.168.026-.048-.131-.12.184-.072.104.048.132-.096.13.072.184-.192.158.072.052-.144.131.024.21.24-.078.192.078.072-.078.192.052.144zm-.186-1.253l.175-.145.064.145-.064.086-.016-.086h-.159z"
      />
    </svg>
  );
}
